// extracted by mini-css-extract-plugin
export default {"openRecordLinkButton":"NotificationBouncedEmailModal_openRecordLinkButton__iTYt6"};